import { supabase } from '@/lib/supabase'

// ── Sports ─────────────────────────────────────────────────────────

export async function fetchSports({ searchTerm } = {}) {
  let query = supabase
    .from('sports')
    .select('id, name, description, is_active, created_at, updated_at')

  if (searchTerm) {
    query = query.ilike('name', `%${searchTerm}%`)
  }

  const { data, error } = await query.order('name')
  if (error) throw error
  // Pickleball goes first; everything else stays alphabetical. The sports
  // table has no display_order column, so sort on the client.
  if (!Array.isArray(data)) return data
  const isPickleball = (r) => (r?.name || '').trim().toLowerCase() === 'pickleball'
  return [...data].sort((a, b) => {
    const aPB = isPickleball(a)
    const bPB = isPickleball(b)
    if (aPB && !bPB) return -1
    if (!aPB && bPB) return 1
    return (a?.name || '').localeCompare(b?.name || '')
  })
}

export async function createSport({ p_name, p_description, p_is_active }) {
  const { error } = await supabase.rpc('admin_create_sport', {
    p_name,
    p_description,
    p_is_active,
  })
  if (error) throw error
}

export async function updateSport({ p_sport_id, p_name, p_description, p_is_active }) {
  const { error } = await supabase.rpc('admin_update_sport', {
    p_sport_id,
    p_name,
    p_description,
    p_is_active,
  })
  if (error) throw error
}

export async function setSportActive({ p_sport_id, p_is_active, p_cascade_to_divisions = true }) {
  const { error } = await supabase.rpc('admin_set_sport_active', {
    p_sport_id,
    p_is_active,
    p_cascade_to_divisions,
  })
  if (error) throw error
}

export async function deleteSport({ p_sport_id }) {
  const { error } = await supabase.rpc('admin_delete_sport', {
    p_sport_id,
  })
  if (error) throw error
}

// ── Divisions ──────────────────────────────────────────────────────

export async function fetchDivisions(sportId) {
  const { data, error } = await supabase
    .from('divisions')
    .select('id, sport_id, name, description, gender, team_size, is_active, created_at, updated_at')
    .eq('sport_id', sportId)
    .order('name')
  if (error) throw error
  return data
}

export async function createDivision({ p_sport_id, p_name, p_description, p_gender, p_team_size, p_is_active }) {
  const { error } = await supabase.rpc('admin_create_division', {
    p_sport_id,
    p_name,
    p_description,
    p_gender,
    p_team_size,
    p_is_active,
  })
  if (error) throw error
}

export async function updateDivision({ p_division_id, p_name, p_description, p_gender, p_team_size, p_is_active }) {
  const { error } = await supabase.rpc('admin_update_division', {
    p_division_id,
    p_name,
    p_description,
    p_gender,
    p_team_size,
    p_is_active,
  })
  if (error) throw error
}

export async function deleteDivision({ p_division_id }) {
  const { error } = await supabase.rpc('admin_delete_division', {
    p_division_id,
  })
  if (error) throw error
}
